import { type CatalogItem, type FindView, type ResolveResult, isMultiPart, itemPart, slotLabel } from '../models/types';
import { Bubble } from '../components/Bubble';
import { RarityBadge } from '../components/RarityBadge';
import { Sheet } from '../components/Sheet';
import { isBusy, useScan } from '../state/scan';
import { rarityColors } from '../theme';

/** Bottom sheet for a find: emoji, name, rarity, description, Pick up / Leave behind. */
export function FindResultSheet({ find, item, onDone }: { find: FindView; item: CatalogItem; onDone: (result: ResolveResult | null) => void }) {
  const part = itemPart(item, find.partId);
  const busy = useScan((s) => isBusy(s));
  const color = rarityColors[find.rarity];

  const resolve = async (pickup: boolean) => {
    const result = await useScan.getState().resolve({ pickup });
    onDone(result);
  };

  return (
    <Sheet dismissible={false} label="You found something">
      <h2 className="t-headline t-center">{part ? 'You found a part!' : 'You found something!'}</h2>
      <Bubble color={item.palette} border={`4px solid ${color}`} padding={24} style={{ marginTop: 16, textAlign: 'center' }} className="item-hero">
        <div className="emoji" style={{ fontSize: 88 }}>{item.emoji}</div>
        <div className="t-headline" style={{ fontWeight: 900, marginTop: 8 }}>{part?.name ?? item.name}</div>
        {part && <div style={{ color: 'rgba(43,45,66,0.7)' }}>part of {item.name}</div>}
        <div style={{ margin: '10px 0' }}><RarityBadge rarity={find.rarity} /></div>
        {item.slot && <div className="t-label" style={{ marginTop: 8 }}>Wear it on: {slotLabel(item.slot)}</div>}
        <p style={{ marginTop: 14 }}>{item.description}</p>
        {isMultiPart(item) && <div className="t-label" style={{ marginTop: 10 }}>🧩 {item.parts.length} parts to assemble</div>}
      </Bubble>
      <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
        <button type="button" className="btn outlined" style={{ flex: 2, padding: '18px 12px', whiteSpace: 'nowrap' }} disabled={busy} onClick={() => void resolve(false)}>
          Leave behind
        </button>
        <button type="button" className="btn filled" style={{ flex: 3, background: color }} disabled={busy} onClick={() => void resolve(true)}>
          {busy ? <span className="spinner" /> : '🤚'} Pick up
        </button>
      </div>
    </Sheet>
  );
}
